import { Close as IconClose } from 'education-icons';
import { SimpleCallback } from 'platform-components';
import React, { ReactNode, useEffect, useRef } from 'react';

import './problem-view__side-panel.scss';

interface clickEvent extends Event {
    target: Element;
}

export interface SidePanelProps {
    header?: React.ReactNode;
    ignoredElements: Array<React.RefObject<HTMLDivElement>>;
    children?: ReactNode;
    onOutsideClick: SimpleCallback;
}

interface Props extends SidePanelProps {}

export const ProblemViewSidePanel = ({ children, header, ignoredElements, onOutsideClick }: Props) => {
    const sidePanelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const mouseDownHandler = (event: clickEvent) => {
            const shouldIgnore = ignoredElements.some((element) => element?.current?.contains(event.target));

            if (!shouldIgnore && !sidePanelRef?.current?.contains(event.target)) {
                onOutsideClick();
            }
        };

        window.addEventListener('mousedown', mouseDownHandler);

        return () => window.removeEventListener('mousedown', mouseDownHandler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="problem-view__side-panel" ref={sidePanelRef}>
            <IconClose className="problem-view__side-panel-close" onClick={onOutsideClick} />
            {header && <div className="problem-view__side-panel-header">{header}</div>}
            <div className="problem-view__side-panel-content">{children}</div>
        </div>
    );
};

export default ProblemViewSidePanel;
